import { Col, Row } from '@landsbankinn/ui-kit';
import { type ReactNode, useRef } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';

export function ButtonContainer(props: {
  children?: ReactNode;
  isConsentFlow?: boolean;
  isLandsbankiClient?: boolean;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { isMobile } = useScreenSize();

  const useDoubleButtonHorizontal =
    props.isConsentFlow && props.isLandsbankiClient && !isMobile;

  return (
    <>
      {useDoubleButtonHorizontal && (
        <Row
          paddingTop="99"
          paddingBottom="8"
          paddingHorizontal="30"
          borderTop="thin"
          borderColor="common gray gray10"
        >
          {props.children}
        </Row>
      )}
      {!useDoubleButtonHorizontal && (
        <Col paddingBottom={isMobile ? '68' : '0'} ref={containerRef}>
          {props.children}
        </Col>
      )}
    </>
  );
}
